import { useTranslation } from 'react-i18next';
import { usageSection } from '@/mocks/certificateData';

export default function UsageSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('certificate.usage.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('certificate.usage.title')}
          </h2>
          <p className="text-accent-400 text-[15px] tracking-[0.12em] mb-4 font-label">
            {usageSection.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          {String(t('certificate.usage.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="space-y-4 mb-8">
          {usageSection.points.map((point, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 bg-primary-800/50 p-5"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-accent-500/15 rounded-full">
                <i className={`${point.icon} text-accent-400 text-base`}></i>
              </div>
              <div>
                <h3 className="text-[16px] text-foreground-50 tracking-[0.05em] font-medium mb-1">
                  {t(`certificate.usage.point.${idx}.title`)}
                </h3>
                <p className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed">
                  {t(`certificate.usage.point.${idx}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {String(t('certificate.usage.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
      </div>
    </section>
  );
}
